import login from "../pages/login/login.vue";
export default {
	path: "/login",
	name: "login",
	component: login,
};
